(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Footer compact (23/10/2026) : sur téléphone, Menu, Coordonnées et Informations légales se replient
  // (une rangée par rubrique, ouverte au toucher) ; les règles d'affichage sont dans base.css
  (function () {
    var telephone = window.matchMedia('(max-width: 749px)');
    var titreLegal = (document.documentElement.lang || '').indexOf('hu') === 0 ? 'Jogi információk' : 'Informations légales';

    var preparer = function () {
      var pied = document.querySelector('footer.footer');
      if (!pied || pied.hasAttribute('data-replis')) return;
      pied.setAttribute('data-replis', '');
      var rubriques = [].slice.call(pied.querySelectorAll('.footer__content > .menu-block'));
      [].forEach.call(pied.querySelectorAll('.footer__content > .group'), function (groupe) {
        if (groupe.querySelector(':scope > .text-block.paragraph') && !groupe.querySelector('.newsletter-signup')) rubriques.push(groupe);
      });
      var legal = pied.querySelector('.footer__bottom-bar .policy-list');
      if (legal && legal.querySelector('.policy-list__links')) {
        var ajout = document.createElement('div');
        ajout.className = 'pied-repli__titre-ajoute';
        ajout.innerHTML = '<p></p>';
        ajout.firstChild.textContent = titreLegal;
        legal.insertBefore(ajout, legal.firstChild);
        rubriques.push(legal);
      }
      rubriques.forEach(function (rubrique) {
        var titre = rubrique.querySelector('.pied-repli__titre-ajoute, .text-block.h6');
        if (!titre) return;
        rubrique.classList.add('pied-repli');
        titre.classList.add('pied-repli__titre');
        var basculer = function () {
          var ouvert = rubrique.classList.toggle('est-ouvert');
          titre.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        };
        titre.addEventListener('click', function () { if (telephone.matches) basculer(); });
        titre.addEventListener('keydown', function (e) {
          if (telephone.matches && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); basculer(); }
        });
      });
      // sur téléphone, les titres sont des boutons ; sur ordinateur, de simples titres
      var accessibilite = function () {
        rubriques.forEach(function (rubrique) {
          var titre = rubrique.querySelector('.pied-repli__titre');
          if (!titre) return;
          if (telephone.matches) {
            titre.setAttribute('role', 'button');
            titre.setAttribute('tabindex', '0');
            titre.setAttribute('aria-expanded', rubrique.classList.contains('est-ouvert') ? 'true' : 'false');
          } else {
            titre.removeAttribute('role');
            titre.removeAttribute('tabindex');
            titre.removeAttribute('aria-expanded');
          }
        });
      };
      accessibilite();
      if (telephone.addEventListener) telephone.addEventListener('change', accessibilite);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparer); else preparer();
    document.addEventListener('shopify:section:load', preparer);
  })();

  } catch(e) { console.error(e); }
})();
})();
